import './css/estudiantes.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Espera from '../Espera';
import PerfilLogo from '../usuarios/PerfilLogo.js';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { show_alerta, esCalificacionBaja, esCalificacionIndice2, obtenerOpcionesValorativa, obtenerEstadoInstancias } from '../../funciones.js';

import CONFIG from '../../config';
import MostrarEncabezadoInstancias from './MostrarEncabezadoInstancias.js';
import MostrarEncabezadosActividades from './MostrarEncabezadosActividades.js';

import EstadisticaAsistencia from './EstadisticaAsistencia.js';
import GraficoAsistencia from './GraficoAsistencia.js';
import VerEntrega from './VerEntrega.js';
import InformeValoracion from './InformeValoracion.js';
import CalendarioAsistencia from './CalendarioAsistencia.js';

const MySwal = withReactContent(Swal);

const URL = `${CONFIG.API_URL}/operarEstudiantes.php`;
const URL_CALIFICACIONES = `${CONFIG.API_URL}/operarValoraciones.php`;
const URL_ASISTENCIA = `${CONFIG.API_URL}/operarAsistencia.php`;
const URL_ACTIVIDADES = `${CONFIG.API_URL}/operarActividades.php`;

function Estudiantes({ acceder, rol, configuracion }) {
    const [estudiantes, setEstudiantes] = useState([]);
    // para  acordeon de equipo docente
    const [equipoDocente, setEquipoDocente] = useState([]);
    const [abierto, setAbierto] = useState(false); //para el acordeon de docentes
    const toggleAccordion = () => {
        setAbierto(!abierto);
    };
    //fin variables acordeon equipo docente

    const [valoraciones, setValoraciones] = useState([]); // para traer las Valoraciones de la BD
    const [colInstancias, setColInstancias] = useState([]); // para traer las instancias de evaluacion de la BD

    const [asistencia, setAsistencia] = useState([]); //para trar la asistencia por fecha de la BD
    const [asistenciaAnual, setAsistenciaAnual] = useState([]); //para trar la asistencia anual de la BD
    const [asistenciaGeneral, setAsistenciaGeneral] = useState([]); // asistencia general (curso_grupo = 0)
    const [asistenciaAnualGeneral, setAsistenciaAnualGeneral] = useState([]);
    const [fechasConAsistenciaGeneral, setFechasConAsistenciaGeneral] = useState([]);

    const [actividades, setActividades] = useState([]); //para trar la asistencia de la BD
    const [listaTrayectorias, setListaTrayectorias] = useState([]); // para almacenar trayectorias con criterios del grupo

    const [formValues, setFormValues] = useState({}); // Para almacenar los valores seleccionados de los select notas
    const [formValuesAsistencia, setFormValuesAsistencia] = useState({}); // Para almacenar los valores seleccionados de los select asistencia

    const [visible, setVisible] = useState(false);
    const rolNum = Number(rol);

    const [vista, setVista] = useState(
        (rolNum === 5 || rolNum === 6 || rolNum === 9) 
            ? 'asistencia' 
            : 'calificaciones'
    );
    const [fechaHoy, setFechaHoy] = useState(() =>
    new Date().toLocaleDateString('sv-SE')
    );

    const [fechaSeleccionada, setFechaSeleccionada] = useState(fechaHoy);

    const loggeduserCurso = localStorage.getItem('loggeduserCurso');
    const loggeduserCursoGrupo = localStorage.getItem('loggeduserCursoGrupo');
    const loggeduserId = localStorage.getItem('loggedUserId');

    const obtenerListaTrayectorias = (cg) => {
        if (cg) {
            axios.get(`${CONFIG.API_URL}/operarTrayectorias.php?id_curso_grupo=${cg}`)
                .then(res => {
                    if (Array.isArray(res.data)) {
                        setListaTrayectorias(res.data);
                    }
                })
                .catch(err => console.log("Error al cargar trayectorias en Estudiantes:", err));
        }
    };

    useEffect(() => {
        obtenerListaTrayectorias(loggeduserCursoGrupo);
    }, [loggeduserCursoGrupo]);

    const mostrarVisorDescripcion = (estudiante, instancia, calificacionObj, trayectoria, puedeEditar = false) => {
        const valorCalificacion = typeof calificacionObj === 'object' ? (calificacionObj?.valor || '') : (calificacionObj || '');
        
        // Buscar el comentario desde la tabla trayectoria_evaluaciones para el estudiante
        let observacionTxt = '';
        if (trayectoria?.evaluaciones && Array.isArray(trayectoria.evaluaciones)) {
            const evalEst = trayectoria.evaluaciones.find(
                e => String(e.id_estudiante) === String(estudiante.id) && e.comentario && e.comentario.trim() !== ''
            );
            if (evalEst) {
                observacionTxt = evalEst.comentario;
            }
        }
        if (!observacionTxt && typeof calificacionObj === 'object') {
            observacionTxt = calificacionObj?.observacion || calificacionObj?.comentario || '';
        }

        const crit = trayectoria?.criterios?.find(
            c => String(c.criterio).trim().toLowerCase() === String(valorCalificacion || '').trim().toLowerCase()
        );

        const tituloNivel = valorCalificacion 
            ? `Nivel alcanzado: <span class="badge bg-success-subtle text-success border border-success fw-bold px-2 py-1">${valorCalificacion}</span>` 
            : '<span class="badge bg-secondary-subtle text-secondary border px-2 py-1">Sin calificación registrada</span>';

        const descripcionCriterioHtml = crit && crit.descripcion 
            ? `<div class="p-3 bg-light rounded text-start border mt-2">
                <p class="mb-1 text-dark fw-bold small">Descripción del nivel alcanzado:</p>
                <p class="mb-0 text-secondary small">${crit.descripcion}</p>
               </div>`
            : `<div class="p-3 bg-light rounded text-start text-muted border mt-2 small">
                <em>${valorCalificacion ? 'No hay una descripción de logro cargada para este nivel en la trayectoria.' : 'Seleccione una calificación para visualizar su descripción.'}</em>
               </div>`;

        const comentarioSeccionHtml = puedeEditar 
            ? `<div class="mt-3 text-start">
                <label class="form-label fw-bold text-dark small mb-1">
                    <i class="fa-regular fa-comment-dots text-primary me-1"></i>Comentario / Observación:
                </label>
                <textarea id="swalComentarioInput" class="form-control form-control-sm" rows="3" placeholder="Ingrese una observación o comentario para el estudiante...">${observacionTxt}</textarea>
               </div>`
            : `<div class="mt-3 text-start border-top pt-2">
                <p class="mb-1 text-dark fw-bold small"><i class="fa-regular fa-comment-dots text-primary me-1"></i>Comentario / Observación:</p>
                <p class="mb-0 text-secondary small fst-italic">${observacionTxt && observacionTxt.trim() !== '' ? `"${observacionTxt}"` : 'Sin comentarios de trayectoria registrados.'}</p>
               </div>`;

        MySwal.fire({
            title: `<span class="fs-5 text-dark fw-bold"><i class="fa-solid fa-route text-success me-2"></i>${trayectoria.titulo}</span>`,
            html: `
                <div class="text-start small">
                    <p class="mb-1 text-secondary"><strong>Estudiante:</strong> ${estudiante.nombre} ${estudiante.apellido}</p>
                    <p class="mb-2 text-secondary"><strong>Instancia:</strong> ${instancia.nombre_instancia || ''}</p>
                    <p class="mb-1">${tituloNivel}</p>
                    ${descripcionCriterioHtml}
                    ${comentarioSeccionHtml}
                </div>
            `,
            showCancelButton: puedeEditar,
            confirmButtonText: puedeEditar ? '<i class="fa-solid fa-floppy-disk me-1"></i>Guardar Comentario' : 'Cerrar',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-success rounded-pill px-4 me-2',
                cancelButton: 'btn btn-secondary rounded-pill px-4'
            },
            buttonsStyling: false,
            preConfirm: () => {
                if (puedeEditar) {
                    const el = document.getElementById('swalComentarioInput');
                    return el ? el.value : '';
                }
                return null;
            }
        }).then((result) => {
            if (result.isConfirmed && puedeEditar && result.value !== null) {
                const nuevoComentario = result.value;
                axios.post(`${CONFIG.API_URL}/operarValoraciones.php`, {
                    modo: 'guardarInformeValoraciones',
                    id_estudiante: estudiante.id,
                    id_instancia: instancia.id,
                    id_curso: loggeduserCurso,
                    informe: nuevoComentario
                })
                .then(res => {
                    if (!res.data.error) {
                        MySwal.fire('Éxito', 'Comentario guardado correctamente', 'success');
                        obtenerEstudiantesyValoraciones(loggeduserCurso);
                        if (loggeduserCursoGrupo) {
                            obtenerListaTrayectorias(loggeduserCursoGrupo);
                        }
                    } else {
                        MySwal.fire('Error', res.data.message || 'No se pudo guardar el comentario', 'error');
                    }
                })
                .catch(err => {
                    console.error(err);
                    MySwal.fire('Error', 'Error al conectar con el servidor', 'error');
                });
            }
        });
    };
    
    const navigate = useNavigate();

    const [entregaSeleccionada, setEntregaSeleccionada] = useState(null);
    const [verEditarInforme, setVerEditarInforme] = useState({ instancia:null, estudiante:null, editar:null });
    const [verCalendarioAsistenciaCargada, setVerCalendarioAsistenciaCargada] = useState(false);

    // ejemplo: fechas donde ya cargaste asistencia
    const [fechasConAsistencia, setFechasConAsistencia] = useState([]);

    useEffect(() => {
        if (acceder) {
            if (rol === null) {
                navigate("/");
            } else {  
                const data = {
                    'id_curso': loggeduserCurso,
                    'id_grupo': loggeduserCursoGrupo,
                    'modo': 'buscarEstudiantesCurso'
                };
                obtenerEstudiantesyValoraciones(data);
                obtenerAsistencia();
                obtenerActividades();
            }
        } else {
            localStorage.clear();
            navigate('/');
        }                   
    }, [acceder, rol, navigate, loggeduserCurso, loggeduserCursoGrupo]);

    useEffect(() => {
        if (vista === 'asistencia') {
            obtenerAsistencia();
            setFormValuesAsistencia({}); // Limpia los selects
        }
    }, [fechaSeleccionada, vista]);

    //funcion para  poner todos los estudiantes conpresente antes de guardar
    const marcarTodosComoPresentes = () => {
        const nuevosValores = { ...formValuesAsistencia };

        estudiantes.forEach(est => {
            const yaTieneAsistencia = asistencia.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada);
            if (!yaTieneAsistencia) {
                nuevosValores[`${est.id}_`] = {
                    id_usuario: est.id,
                    valor: 'Presente'
                };
            }
        });
        setFormValuesAsistencia(nuevosValores);
    };

    //funcion para obtener los estudiantes y sus valoraciones
    const obtenerEstudiantesyValoraciones = (dato) => {
        setVisible(true);
        axios.post(URL, dato)
        .then(res => {
            if (!res.data.error) {
                console.log("estudiantes:",res.data.valoraciones); 
                setEstudiantes(res.data.estudiantes);
                setValoraciones(res.data.valoraciones);
                if (res.data.equipo_docente) {
                    setEquipoDocente(res.data.equipo_docente);
                }else{
                    setEquipoDocente([]);
                }
            } else {
                setEstudiantes([]);
                setValoraciones([]);
                setEquipoDocente([]);
            }
            setVisible(false);
        })
        .catch(err => {
            console.log(err);
        });
    }

    //funcion para obtener la asistencia 
    const obtenerAsistencia = () => {
        const dataAsistencia = {
            modo: 'obtenerAsistencia',
            fecha: fechaSeleccionada,
            curso: loggeduserCursoGrupo
        };
        axios.post(URL_ASISTENCIA, dataAsistencia)
        .then(res => {
            if (!res.data.error) {
                console.log('asis:'+JSON.stringify(res.data));
                setAsistencia(res.data.asistencias || []);
                setAsistenciaAnual(res.data.asistencias_anual || []);
                const fechasUnicas = [...new Set((res.data.asistencias_anual || []).map(a => a.fecha))];
                setFechasConAsistencia(fechasUnicas);

                setAsistenciaGeneral(res.data.asistencias_general || []);
                setAsistenciaAnualGeneral(res.data.asistencias_anual_general || []);
                const fechasUnicasGen = [...new Set((res.data.asistencias_anual_general || []).map(a => a.fecha))];
                setFechasConAsistenciaGeneral(fechasUnicasGen);
            } else {
                setAsistencia([]);
                setAsistenciaAnual([]);
                setFechasConAsistencia([]);
                setAsistenciaGeneral([]);
                setAsistenciaAnualGeneral([]);
                setFechasConAsistenciaGeneral([]);
            }
        })
        .catch(err => {
            console.error('Error al obtener asistencia:', err);
        });
    }

    //funcion para obtener las actividades, cuestionarios y evaluaciones
    const obtenerActividades = async () => {
        try {
            const [resAct, resCues, resEval] = await Promise.all([
                axios.get(`${URL_ACTIVIDADES}?id_curso_grupo=${loggeduserCursoGrupo}&rol=${rol}`).catch(() => ({ data: { success: false } })),
                axios.get(`${CONFIG.API_URL}/operarCuestionario.php?modo=listarResultadosGrupo&id_curso_grupo=${loggeduserCursoGrupo}`).catch(() => ({ data: { success: false } })),
                axios.get(`${CONFIG.API_URL}/operarEvaluaciones.php?id_curso_grupo=${loggeduserCursoGrupo}`).catch(() => ({ data: { error: true } }))
            ]);

            let acts = [];
            if (resAct.data && resAct.data.success && Array.isArray(resAct.data.actividades)) {
                acts = acts.concat(resAct.data.actividades);
            }
            if (resCues.data && resCues.data.success && Array.isArray(resCues.data.cuestionarios)) {
                acts = acts.concat(resCues.data.cuestionarios);
            }
            if (resEval.data && !resEval.data.error && Array.isArray(resEval.data.evaluaciones)) {
                const evalsFormateadas = resEval.data.evaluaciones.map(ev => ({
                    id: `Eval`,
                    id_eval: ev.id,
                    titulo: ev.titulo,
                    modalidad: ev.modalidad,
                    fecha: ev.fecha,
                    es_evaluacion: true,
                    resultados: ev.resultados || []
                }));
                acts = acts.concat(evalsFormateadas);
            }
            setActividades(acts);
        } catch (err) {
            console.error('Error al obtener actividades y evaluaciones:', err);
            setActividades([]);
        }
    };

    // Función para manejar el cambio de vista
    const handleVistaChange = (nuevaVista) => {
        setVista(nuevaVista);
    }

    
    const eliminarEstudiante = (id) =>{
        const MySwal= withReactContent(Swal); 
        MySwal.fire({
            title: '¿Seguro de Quitar al/la estudiante de la clase?',
            icon: 'warning', 
            html: '<span class=\"text-muted\">si desea volvera ingresarlo lo debera hacer el administrador</span>',
            showCancelButton: true, confirmButtonText: '<i class="fa-solid fa-trash-can"></i> Si, eliminar', cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-danger mx-2 shadow-sm',
                cancelButton: 'btn btn-outline-secondary mx-2',
                popup: 'rounded-4 shadow'
            },
            buttonsStyling: false
        })
        .then(res=>{
            if(res.isConfirmed){
                enviarSolicitud('DELETE',{'id':id,'id_grupo': loggeduserCursoGrupo,'modo': 'eliminarEstudiante'})
            }
        });
    };

    const enviarSolicitud = async (metodo, parametros) =>{
        setVisible(true);
        await axios({method:metodo, url:URL, data:parametros})
            .then(res => {
                if (!res.data.error) {
                    // Filtra al estudiante eliminado de la lista
                    setEstudiantes(estudiantes.filter(e => e.id !== parametros.id));
                    console.log("resdataEstudiantes:",res.data);
                    var tipo = res.data[0];
                    var msj = res.data[1];
                    show_alerta(msj,tipo);    
                } else {
                    alert('Error al eliminar al estudiante');
                }
                setVisible(false);
            })
            .catch(err => {
                show_alerta('Error en la solicitud ','error');
                console.log(err);
                setVisible(false);
            });
    };
    
    // Manejar cambios en los select de notas
    const handleSelectChange = (idUsuario, idInstancia, idCurso, valor) => {
        console.log('usuario:'+idUsuario+'instancia:'+idInstancia+'curso:'+idCurso+'valor:'+valor);
        setFormValues((prev) => ({
            ...prev,
            [`${idUsuario}_${idInstancia}_${idCurso}`]: { id_usuario: idUsuario, id_instancia: idInstancia, id_curso: idCurso, valor: valor }
        }));
    };

    // Manejar cambios en los select de asistencia
    const handleSelectInasistenciaChange = (idUsuario, valor) => {
        //console.log('usuario:'+idUsuario+' valor:'+valor);
        setFormValuesAsistencia((prev) => ({
            ...prev,
            [`${idUsuario}_`]: { id_usuario: idUsuario, valor: valor }
        }));
    };

    // Enviar valores al backend
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(vista==='calificaciones'){ 
            const data = Object.values(formValues);

            if (data.length === 0) {
                Swal.fire('Error', 'No hay cambios que guardar', 'error');
                return;
            }
        
            const response = await axios.post(URL_CALIFICACIONES, { 'modo': 'guardarValoraciones','valoraciones': data });
            console.log(response.data);
            if (!response.data.error) {
                Swal.fire('Éxito', 'Calificaciones guardadas', 'success');
                setValoraciones((prev) =>
                    prev.map((v) =>
                        data.find((d) => d.id_usuario === v.id_usuario && d.id_instancia === v.id_instancia)
                            ? { ...v, ...data.find((d) => d.id_usuario === v.id_usuario && d.id_instancia === v.id_instancia) }
                            : v
                    )
                );
            } else {
                Swal.fire('Error', response.data.message, 'error');
            }
        }
        if(vista==='asistencia'){ 
             const data = Object.values(formValuesAsistencia);

            if (data.length === 0) {
                Swal.fire('Error', 'No hay cambios que guardar', 'error');
                return;
            }
            //console.log('data:'+JSON.stringify(data));
            const response = await axios.post(URL_ASISTENCIA, { 'modo': 'guardarAsistencia', 'fecha':fechaSeleccionada, 'curso':loggeduserCursoGrupo, 'responsable':loggeduserId, 'valores': data });
            console.log('Asistencia:'+response.data);
            if (!response.data.error) {
                Swal.fire('Éxito', 'Asistencia guardad', 'success');
                setAsistencia((prev) =>
                    prev.map((asis) =>
                        data.find((d) => d.id_usuario === asis.id_usuario && d.fecha === asis.fecha && d.curso === asis.curso)
                            ? { ...asis, ...data.find((d) => d.id_usuario === asis.id_usuario && d.id_instancia === asis.fecha && d.curso === asis.curso) }
                            : asis
                    )
                );
                obtenerAsistencia();
            } else {
                Swal.fire('Error', response.data.message, 'error');
            }            
        }
    };


    return (
    <>
        <div className="container-principal">
            <small>curso: #{loggeduserCurso}</small><small>curso_grupo: #{loggeduserCursoGrupo}</small>            
            <div className="accordion accordion-flush mb-2">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button
                            className={`bg-primary-subtle border border-primary-subtle accordion-button ${!abierto ? "collapsed" : ""}`}
                            type="button"
                            onClick={toggleAccordion}
                        >
                            <span className='estudiantes-titulo'>Equipo Docente</span>
                            <span className='small'>
                                ({equipoDocente.length === 1
                                ? `${equipoDocente.length} docente`
                                : `${equipoDocente.length} docentes`}
                                )
                            </span>
                        </button>
                    </h2>
                    <div className={`accordion-collapse collapse ${abierto ? "show" : ""}`}>
                        <div className="accordion-body">
                            <table className="table">
                                <tbody>
                                    {equipoDocente.map((est) => (
                                    <tr key={est.id}>
                                        <td className="col-sm-5 col-12">
                                            <PerfilLogo usuario={est} version="extendida+" configuracion={configuracion} />
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <h3 className='estudiantes-titulo'>Estudiantes
                {rol == 1 && 
                <button type='button' className='btn btn-outline-info btn-sm'>
                    + <i className="fa-solid fa-graduation-cap"></i>
                </button>
                }
            </h3>
            <h5 className='estudiantes-titulo2'>
                {estudiantes.length ===1?`${estudiantes.length} estudiante`:`${estudiantes.length} estudiantes` } 
            </h5>
            {/* rol docente */}   
            {/* selector de pestañas (calificaciones|asistencia|actividades) solo para docentes y directivos */}
            {(rol == 6 || rol == 5 || rol == "6" || rol == "5" || rol == 9 || rol == "9") &&
                <div className='row'>
                    <div className="col-12">
                        <ul className="nav nav-tabs justify-content-end">
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${vista === 'calificaciones' ? 'active' : ''}`} 
                                    onClick={() => handleVistaChange('calificaciones')}
                                >
                                    Calificaciones
                                </button>
                            </li>
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${vista === 'asistencia' ? 'active' : ''}`} 
                                    onClick={() => handleVistaChange('asistencia')}
                                >
                                    Asistencia
                                </button>
                            </li>
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${vista === 'actividades' ? 'active' : ''}`} 
                                    onClick={() => handleVistaChange('actividades')}
                                >
                                    Actividades
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            }

            {!visible ? 
                <>
                {vista === 'calificaciones' && (() => {
                    const estadoInstancias = obtenerEstadoInstancias(colInstancias);
                    if (!estadoInstancias) return null;
                    return estadoInstancias.abierta ? (
                        <div className="alert alert-success py-2 px-3 small mb-3 d-flex align-items-center flex-wrap gap-2" role="alert">
                            <i className="fa-solid fa-lock-open me-1"></i>
                            <span>
                                <strong>Instancia abierta:</strong>{' '}
                                {estadoInstancias.abiertas.map((inst, idx) => (
                                    <span key={inst.id || idx}>
                                        {idx > 0 && ' • '}
                                        <strong>{inst.nombre}</strong> (hasta el {inst.cierreFormateado})
                                    </span>
                                ))}
                            </span>
                        </div>
                    ) : (
                        <div className="alert alert-warning py-2 px-3 small mb-3 d-flex align-items-center flex-wrap gap-2" role="alert">
                            <i className="fa-solid fa-lock me-1"></i>
                            <span><strong>Todas las instancias están cerradas.</strong></span>
                            {estadoInstancias.ultimaCerrada && (
                                <span>
                                    • <strong>Última instancia:</strong> {estadoInstancias.ultimaCerrada.nombre} (cerró el {estadoInstancias.ultimaCerrada.cierreFormateado})
                                </span>
                            )}
                            {estadoInstancias.proximaAbrir && (
                                <span>
                                    • <strong>Próxima instancia:</strong> {estadoInstancias.proximaAbrir.nombre} (abre el {estadoInstancias.proximaAbrir.inicioFormateado})
                                </span>
                            )}
                        </div>
                    );
                })()}
                {estudiantes.length > 0 ? (
                    <form onSubmit={handleSubmit}>
                        
                        <table className="table">
                            <thead>
                            {vista === 'asistencia' &&
                                <tr>
                                    <th colSpan={5}><EstadisticaAsistencia asistencia={asistencia} asistenciaGeneral={asistenciaGeneral} fechaSeleccionada={fechaSeleccionada}/></th>
                                </tr>
                            }
                            {(rol === 7|| rol ===8 || rol === "7" || rol === "8") &&
                                <tr>
                                    <th colSpan={3}><EstadisticaAsistencia id_usuario={loggeduserId} asistencia={asistencia} fechaSeleccionada={fechaSeleccionada}/></th>
                                </tr>
                            }
                                <tr>
                                    <th>Estudiante/s curso</th>
                                   
                                {(rol == 6 || rol == 5 || rol == "6" || rol == "5" || rol == 9 || rol == "9") && 
                                <>
                                    {vista === 'calificaciones' && (
                                        <MostrarEncabezadoInstancias
                                            curso={loggeduserCurso}
                                            cursoGrupo={loggeduserCursoGrupo}
                                            setColInstancias={setColInstancias}
                                            estudiantes={estudiantes}
                                            valoraciones={valoraciones}
                                            recalcularValoraciones={() => obtenerEstudiantesyValoraciones(loggeduserCurso)}
                                        />
                                    )}
                                        
                                    {vista === 'asistencia' && (
                                        <>
                                         <th className="py-2">
                                             <div className='d-flex align-items-center justify-content-center gap-2 flex-wrap'>
                                                 <button 
                                                     type="button"
                                                     className="btn btn-sm btn-outline-primary py-1 px-2"
                                                     style={{ fontSize: '0.8rem' }}
                                                     onClick={() => setVerCalendarioAsistenciaCargada(!verCalendarioAsistenciaCargada)}
                                                 >
                                                     <i className="fa-regular fa-calendar-days me-1"></i>
                                                     {verCalendarioAsistenciaCargada ? 'Ocultar asistencia' : 'Ver asistencia cargada'}
                                                 </button>

                                                 <div className="d-flex align-items-center gap-1 border rounded px-2 py-1 bg-light" title="Asistencia cargada por Preceptoría">
                                                     <i className="fa-solid fa-clipboard-user me-1" style={{ color: '#75b798', fontSize: '0.85rem' }}></i>
                                                     <input
                                                         type="date"
                                                         className="form-control form-control-sm py-0 px-1 border-0 bg-transparent"
                                                         style={{ fontSize: '0.8rem', width: 'auto' }}
                                                         value={fechaSeleccionada}
                                                         onChange={(e) => setFechaSeleccionada(e.target.value)}
                                                         max={fechaHoy}
                                                     />
                                                 </div>

                                                 <button
                                                     type="button"
                                                     className="btn btn-sm btn-success py-1 px-2"
                                                     style={{ fontSize: '0.8rem' }}
                                                     onClick={marcarTodosComoPresentes}
                                                 >
                                                     <i className="fa-solid fa-check-double me-1"></i>
                                                     Marcar todos Presentes
                                                 </button>
                                             </div>

                                             {verCalendarioAsistenciaCargada && (
                                                 <div className="mt-2 text-center">
                                                     <CalendarioAsistencia 
                                                         fechasConAsistencia={fechasConAsistencia}
                                                         fechasConAsistenciaGeneral={fechasConAsistenciaGeneral}
                                                         fechaSeleccionada={fechaSeleccionada}
                                                         setFechaSeleccionada={setFechaSeleccionada}
                                                     />
                                                 </div>
                                             )}
                                         </th>
                                         <th className='text-center align-middle' style={{ fontSize: '0.8rem' }} title="Asistencia Diaria Anual (Escuela - Preceptor)">
                                             <i className="fa-solid fa-clipboard-user me-1" style={{ color: '#75b798' }}></i> Diaria
                                         </th>
                                         <th className='text-center align-middle' style={{ fontSize: '0.8rem' }} title="Asistencia de la Materia Anual (Docente)">
                                             <i className="fa-solid fa-chart-pie me-1 text-success"></i> Espacio
                                         </th>
                                        </>
                                    )}    
                                        
                                    {vista === 'actividades' && (
                                        <MostrarEncabezadosActividades
                                            actividades={actividades}
                                        />
                                    )}
                                </>}
                                    {(rol == 6 || rol == 5 || rol == "6" || rol == "5" || rol == 9 || rol == "9") &&
                                    <th className="col-sm-3 col-12 estudiante-botonera">acc.</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                            {/* Listado de estudiantes */}
                            {estudiantes.map((est) => (
                                <tr key={est.id}>
                                    <td className="col-sm-5 col-12">
                                       {(rol!=7 && rol !=8 && rol !=5 && rol !=6)? 
                                            <Link to={ `/VerPerfil/e/${est.id}`} className='decoracion-perfil' >
                                            <PerfilLogo usuario={est} version="extendida+" configuracion={configuracion} />
                                            </Link>
                                        :
                                        <>
                                            <PerfilLogo usuario={est} version="extendida+" configuracion={configuracion} />
                                        </>
                                        }
                                    </td>
                                {/* calificaciones */}  
                                    {vista === 'calificaciones' &&
                                         colInstancias.map((i, index) => {
                                             const calificacion = valoraciones.find(
                                                 (v) => String(v.id_instancia) === String(i.id) && String(v.id_usuario) === String(est.id)
                                             );
                                            const fechaActual = new Date();
                                            const fechaInicio = new Date(i.fecha_inicio);
                                            const fechaCierre = new Date(i.fecha_cierre);

                                            const esAprobadaOPublicada = calificacion && (calificacion.estado_aprobacion === 'aprobada' || calificacion.estado_aprobacion === 'publicada' || calificacion.estado_aprobacion === 'vista_por_tutor');
                                            const habilitarInput = (fechaActual >= fechaInicio && fechaActual <= fechaCierre) && !esAprobadaOPublicada;

                                            // Seleccionar el arreglo de opciones basado en el tipo de calificación
                                            let opciones = []; 
                                            if (i.tipo_calificacion === 'Valorativa' || i.tipo_calificacion === 'Valorativa 1' || i.tipo_calificacion === 'Valorativa 2' || i.tipo_calificacion === 'Valorativa 3') {
                                                const opcionesParsed = obtenerOpcionesValorativa(i.tipo_calificacion, configuracion);
                                                // Reordenar opciones para colocar primero las valoraciones más altas si es necesario
                                                let opcionesList = [...opcionesParsed];
                                                let tieneVacioInicial = false;
                                                if (opcionesList.length > 0 && (opcionesList[0] === '' || opcionesList[0] === null)) {
                                                    tieneVacioInicial = true;
                                                    opcionesList.shift();
                                                }
                                                opcionesList.reverse();
                                                if (tieneVacioInicial) {
                                                    opcionesList.unshift('');
                                                }
                                                opciones = opcionesList;
                                            } else if (i.tipo_calificacion === 'Numerica') {
                                                opciones = [0, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
                                            } else if (i.tipo_calificacion === 'Logro') {
                                                opciones = ['', 'Logrado', 'pendiente'];
                                            } else if (i.tipo_calificacion === 'Participacion') {
                                                opciones = ['', 'Participo', 'no participo'];
                                            }
                                            const trayEncontrada = listaTrayectorias.find(t => String(t.id_instancia) === String(i.id));
                                             const esNotaBaja = calificacion ? esCalificacionBaja(calificacion.valor, i.tipo_calificacion, configuracion) : false;
                                             const esNota2 = calificacion ? esCalificacionIndice2(calificacion.valor, i.tipo_calificacion, configuracion) : false;
                                             const claseColor = esNotaBaja ? 'text-danger fw-bold' : (esNota2 ? 'text-warning-emphasis text-warning fw-bold' : 'fw-bold text-dark');
                                             return (
                                             <td key={index} className="col text-center">
                                             {(rol == 6 || rol == 5 || rol == "6" || rol == "5") ?
                                             <div className='d-flex justify-content-center align-items-center'>
                                                 {!habilitarInput ? (
                                                     <span className={claseColor}>
                                                         {calificacion ? calificacion.valor : '-'}
                                                     </span>
                                                 ) : (
                                                     <select
                                                         className={` form-select form-select-sm estudiante-select-${i.tipo_calificacion.toLowerCase()} ${
                                                             calificacion ? 'estudiante-calificado' : ''
                                                         } ${esNotaBaja ? 'text-danger fw-bold border-danger' : (esNota2 ? 'text-warning-emphasis text-warning fw-bold border-warning' : 'fw-bold text-dark')}`}
                                                         disabled={!habilitarInput}
                                                         value={
                                                             calificacion?.valor
                                                         }
                                                         onChange={(e) =>
                                                             handleSelectChange(est.id, i.id, loggeduserCurso, e.target.value)
                                                         }
                                                     >                
                                                     {opciones.map((opcion, idx) => {
                                                             const opBaja = esCalificacionBaja(opcion, i.tipo_calificacion, configuracion);
                                                             const op2 = esCalificacionIndice2(opcion, i.tipo_calificacion, configuracion);
                                                             const opColor = opBaja ? 'text-danger fw-bold' : (op2 ? 'text-warning-emphasis text-warning fw-bold' : 'fw-bold text-dark');
                                                             return (
                                                                 <option key={idx} value={opcion} className={opColor}>
                                                                     {opcion}
                                                                 </option>
                                                             );
                                                         })}
                                                     </select>
                                                 )}
                                                 {esAprobadaOPublicada && (
                                                     <span className="ms-1" title={calificacion.estado_aprobacion === 'vista_por_tutor' ? 'Vista por el tutor' : (calificacion.estado_aprobacion === 'publicada' ? 'Publicada' : 'Aprobada')}>
                                                         {calificacion.estado_aprobacion === 'vista_por_tutor' ? 
                                                             <i className="fa-solid fa-eye text-success" style={{fontSize: '0.85rem'}}></i> : 
                                                             (calificacion.estado_aprobacion === 'publicada' ? 
                                                                 <i className="fa-solid fa-bullhorn text-primary" style={{fontSize: '0.85rem'}}></i> : 
                                                                 <i className="fa-solid fa-thumbs-up text-success" style={{fontSize: '0.85rem'}}></i>)
                                                         }
                                                     </span>
                                                 )}
                                                 {trayEncontrada ? (
                                                     <button 
                                                         type='button'
                                                         className='btn btn-sm btn-outline-success ms-1'
                                                         onClick={() => mostrarVisorDescripcion(est, i, calificacion, trayEncontrada, habilitarInput)}
                                                         title="Ver indicador de trayectoria y editar comentario"
                                                     >
                                                         <i className="fa-solid fa-route"></i>
                                                     </button>
                                                 ) : (
                                                     <button 
                                                         type='button'
                                                         className='btn btn-sm btn-outline-secondary ms-1'
                                                         onClick={() => {
                                                                         setVerEditarInforme({ instancia:i.id, estudiante: est.id, editar:habilitarInput });
                                                                     }}
                                                         data-bs-toggle="modal" 
                                                         data-bs-target="#valoracionModal"
                                                     >
                                                         <i className="fa-regular fa-file-lines"></i>
                                                     </button>
                                                 )}
                                             </div>    
                                             : 
                                             <>
                                             {(rol == 9 || rol == "9") &&
                                                 <div className='d-flex justify-content-center align-items-center'>
                                                     <span className={`estudiante-nota-texto fw-bold ${claseColor}`}>
                                                         {(calificacion && (calificacion.estado_aprobacion === 'publicada' || calificacion.estado_aprobacion === 'vista_por_tutor') && calificacion.valor !== null && calificacion.valor !== undefined && String(calificacion.valor).trim() !== '') ? calificacion.valor : '-'}
                                                         {calificacion && calificacion.estado_aprobacion === 'vista_por_tutor' && (
                                                             <i className="fa-solid fa-eye text-success ms-1" title="Vista por el tutor"></i>
                                                         )}
                                                     </span>
                                                    {trayEncontrada ? (
                                                        <button 
                                                            type='button'
                                                            className='btn btn-sm btn-outline-info ms-2'
                                                            onClick={() => mostrarVisorDescripcion(est, i, calificacion, trayEncontrada, false)}
                                                            title="Ver indicador de trayectoria"
                                                        >
                                                            <i className="fa-solid fa-circle-info"></i>
                                                        </button>
                                                    ) : (
                                                        <button 
                                                            type='button'
                                                            className='btn btn-sm btn-outline-secondary ms-2'
                                                            onClick={() => {
                                                                setVerEditarInforme({ instancia:i.id, estudiante: est.id, editar:false });
                                                            }}
                                                            data-bs-toggle="modal" 
                                                            data-bs-target="#valoracionModal"
                                                        >
                                                            <i className="fa-regular fa-file-lines"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            }
                                            </>   
                                            }
                                            </td>
                                            );
                                        })
                                    }

                                {/* asistencia */}
                                    {vista === 'asistencia' && ( 
                                        <>
                                        <td className="">
                                                {(rol == 9 || rol == "9") ? (
                                                    <div className="text-center">
                                                        {asistencia.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada)?.asistencia ||
                                                         asistenciaGeneral.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada)?.asistencia || '-'}
                                                    </div>
                                                ) : (
                                                    <>
                                                        {(() => {
                                                            const asistenciaCurso = asistencia.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada);
                                                            const asistenciaGen = asistenciaGeneral.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada);
                                                            const tieneSeleccionManual = formValuesAsistencia[`${est.id}_`]?.valor !== undefined;
                                                            const valorSelect = (
                                                                formValuesAsistencia[`${est.id}_`]?.valor ??
                                                                asistenciaCurso?.asistencia ??
                                                                asistenciaGen?.asistencia
                                                            ) || '';

                                                            const esCurso = tieneSeleccionManual || !!asistenciaCurso;
                                                            const esGen = !esCurso && !!asistenciaGen;

                                                            const getEstilosSelect = () => {
                                                                if (!valorSelect) return { fontSize: '0.85rem' };
                                                                if (valorSelect === 'Presente') {
                                                                    return {
                                                                        backgroundColor: esCurso ? '#d1e7dd' : '#e8f5e9',
                                                                        color: esCurso ? '#0f5132' : '#1b5e20',
                                                                        borderColor: esCurso ? '#a3cfbb' : '#c8e6c9',
                                                                        fontWeight: '600',
                                                                        fontSize: '0.85rem'
                                                                    };
                                                                }
                                                                if (valorSelect === 'Ausente') {
                                                                    return {
                                                                        backgroundColor: esCurso ? '#f8d7da' : '#ffebee',
                                                                        color: esCurso ? '#842029' : '#b71c1c',
                                                                        borderColor: esCurso ? '#f5c2c7' : '#ffcdd2',
                                                                        fontWeight: '600',
                                                                        fontSize: '0.85rem'
                                                                    };
                                                                }
                                                                if (valorSelect === 'Tarde') {
                                                                    return {
                                                                        backgroundColor: esCurso ? '#fff3cd' : '#fffde7',
                                                                        color: esCurso ? '#664d03' : '#f57f17',
                                                                        borderColor: esCurso ? '#ffe69c' : '#fff9c4',
                                                                        fontWeight: '600',
                                                                        fontSize: '0.85rem'
                                                                    };
                                                                }
                                                                return { fontSize: '0.85rem' };
                                                            };

                                                            const getIconColor = (estado, esPreceptor) => {
                                                                if (estado === 'Presente') return esPreceptor ? '#2e7d32' : '#198754';
                                                                if (estado === 'Ausente') return esPreceptor ? '#c62828' : '#dc3545';
                                                                if (estado === 'Tarde') return esPreceptor ? '#f57f17' : '#d97706';
                                                                return esPreceptor ? '#75b798' : '#198754';
                                                            };

                                                            return (
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <select
                                                                        value={valorSelect}
                                                                        onChange={(e) =>
                                                                            handleSelectInasistenciaChange(est.id, e.target.value)
                                                                        }
                                                                        className="form-select form-select-sm border w-auto"
                                                                        style={getEstilosSelect()}
                                                                    >
                                                                        <option value="" style={{ backgroundColor: '#fff', color: '#000' }}></option>
                                                                        <option value="Presente" style={{ backgroundColor: '#d1e7dd', color: '#0f5132' }}>Presente</option>
                                                                        <option value="Ausente" style={{ backgroundColor: '#f8d7da', color: '#842029' }}>Ausente</option>
                                                                        <option value="Tarde" style={{ backgroundColor: '#fff3cd', color: '#664d03' }}>Tarde</option>
                                                                    </select>
                                                                    {asistenciaGen && (
                                                                        <i 
                                                                            className="fa-solid fa-clipboard-user ms-1" 
                                                                            style={{ color: getIconColor(asistenciaGen.asistencia, true), fontSize: '0.9rem' }} 
                                                                            title={`Asistencia general: ${asistenciaGen.asistencia} (Preceptor)`}
                                                                        ></i>
                                                                    )}
                                                                    {asistenciaCurso && (
                                                                        <i 
                                                                            className="fa-solid fa-check-circle ms-1" 
                                                                            style={{ color: getIconColor(asistenciaCurso.asistencia, false), fontSize: '0.9rem' }} 
                                                                            title={`Asistencia materia: ${asistenciaCurso.asistencia} (Docente)`}
                                                                        ></i>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}
                                                    </>
                                                )}
                                        </td>
                                         <td className="text-center align-middle" title="Asistencia Diaria Anual (Preceptor)">
                                             <GraficoAsistencia asistenciaAnual={asistenciaAnualGeneral} id_usuario={est.id} tipo="diaria" />
                                         </td>
                                         <td className="text-center align-middle" title="Asistencia de la Materia Anual (Docente)">
                                             <GraficoAsistencia asistenciaAnual={asistenciaAnual} id_usuario={est.id} tipo="materia" />
                                         </td>
                                        </>
                                        )
                                    }

                                {/* Actividades */}                                        
                                    {vista === 'actividades' && (
                                            actividades.map((actividad, index) => {
                                                if (actividad.es_evaluacion) {
                                                    const resEst = (actividad.resultados || []).find(
                                                        r => String(r.id_estudiante) === String(est.id)
                                                    );
                                                    return (
                                                        <td key={`eval_${actividad.id_eval}_${index}`} className="text-center align-middle">
                                                            {resEst && resEst.calificacion ? (
                                                                <span
                                                                    className="badge bg-primary px-2 py-1"
                                                                    title={resEst.observacion ? `Observación: ${resEst.observacion}` : 'Calificación de evaluación'}
                                                                >
                                                                    {resEst.calificacion}
                                                                </span>
                                                            ) : (
                                                                <span className="text-muted">-</span>
                                                            )}
                                                        </td>
                                                    );
                                                }

                                                const historialEntregas = actividad.entregas?.filter(e => e.id_estudiante == est.id) || [];
                                                const entregaEstudiante = historialEntregas.length > 0 ? historialEntregas[0] : null;
                                                return (
                                                    <td key={index} className="text-center">
                                                        {entregaEstudiante ? (
                                                            entregaEstudiante.es_cuestionario ? (
                                                                <div className="small">
                                                                    <span className="text-success fw-bold">{Math.round(entregaEstudiante.mejor_acierto * 100)}%</span> / {entregaEstudiante.intentos} int.
                                                                </div>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-success btn-sm"
                                                                    onClick={() => {
                                                                        setEntregaSeleccionada({ entregaEstudiante: entregaEstudiante, historialEntregas: historialEntregas, actividad: actividad });
                                                                    }}
                                                                    data-bs-toggle="modal" 
                                                                    data-bs-target="#exampleModal"
                                                                    >
                                                                    Sí
                                                                </button>
                                                            )
                                                        ) : (
                                                            <span className="text-muted">No</span>
                                                        )}
                                                    </td>
                                                );
                                            })
                                        )
                                    }

                                        <td className="col-sm-3 col-12 estudiante-botonera">
                                            {(rol == 1 || rol == 2 || rol == 3 || rol == 4) && (
                                                <button
                                                    type="button"
                                                    className="btn btn-warning btn-sm"
                                                    onClick={() => eliminarEstudiante(est.id)}
                                                >
                                                    - <i className="fa-solid fa-graduation-cap"></i>
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="text-center">
                        {(rol == 6 || rol == 5 || rol == "6" || rol == "5") && (vista != 'actividades') && 
                            <button type="submit" className="btn btn-primary">
                                Guardar {vista}
                            </button>
                        }
                        </div>
                    </form>
                ) : (
                   <div>Sin estudiantes</div>
                )}                    
                </> 
                : <Espera />
            }
        </div>

                        
{/* Modal para ver entregas*/}
        <div className="modal fade" 
        id="exampleModal" 
        aria-labelledby="exampleModalLabel" 
        aria-hidden="true"
        >
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-6" id="exampleModalLabel"><i className="fa-solid fa-file-lines"></i> Entrega de actividad</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                {entregaSeleccionada && (
                        <VerEntrega 
                            actividad={entregaSeleccionada.actividad}
                            entregaEstudiante={entregaSeleccionada.entregaEstudiante}
                            historialEntregas={entregaSeleccionada.historialEntregas}
                            rol={rol}
                            onEvaluacionGuardada={() => {
                                obtenerActividades();
                                const btnClose = document.querySelector('#exampleModal .btn-close');
                                if (btnClose) btnClose.click();
                            }}
                        />
                )}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
        </div>

{/* Modal para escrivir informe valoracion*/}
        <div className="modal fade" 
        id="valoracionModal" 
        aria-labelledby="valoracionModalLabel" 
        aria-hidden="true"
        >
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-6" id="valoracionModalLabel"><i className="fa-solid fa-file-lines"></i> Informe de la valoracion</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                estudiante:{verEditarInforme.estudiante}
                instancia:{verEditarInforme.instancia}
                <InformeValoracion 
                    estudiante={verEditarInforme.estudiante} 
                    instancia={verEditarInforme.instancia}
                    curso={loggeduserCurso}
                    editar={verEditarInforme.editar}
                    rol={rol}
                />
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
        </div>


    </>
    );
}

export default Estudiantes;